export default [
    { id: "1", label: "all" },
    { id: "2", label: "deployment" },
    { id: "3", label: "build" }
]